import { render, staticRenderFns } from "./PagesEdit.vue?vue&type=template&id=216c90c0&scoped=true&"
import script from "./PagesEdit.vue?vue&type=script&lang=js&"
export * from "./PagesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216c90c0",
  null
  
)

export default component.exports